import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  LongTextCustomFieldFormData,
  LongTextCustomFieldInputData,
  longTextCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/longTextCustomFieldSchema.ts';
import useCreateCustomField from '@/features/dashboard/tourCustomFields/hooks/useCreateCustomField.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import LongTextCustomFieldForm from '@/features/dashboard/tourCustomFields/components/LongTextCustomFieldForm.tsx';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

const LongTextCustomFieldAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<LongTextCustomFieldInputData>({
    resolver: debugZodResolver(longTextCustomFieldSchema),
    defaultValues: {
      type: FieldType.LONG_TEXT,
      rowsNumber: 3,
    },
  });

  const createCustomField = useCreateCustomField(tourId);

  const handleSubmit = (data: LongTextCustomFieldFormData) => {
    createCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Skonfiguruj pole tekstowe długie" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <LongTextCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default LongTextCustomFieldAddModal;
